import React from "react";
import { Card } from "react-bootstrap";
import {
  FaCodeBranch,
  FaUsers,
  FaGitAlt,
  FaCodeMerge,
  FaFolderTree,
  FaCircleExclamation, 
  FaCircleCheck
} from "react-icons/fa6";
import { TbGitPullRequest } from "react-icons/tb"; 

const StatCards = ({ summary, title }) => {


  const repoInfo = summary?.repository_info || {};
  const branchesTotal =
    summary?.branches?.total ?? repoInfo?.branches_count ?? 0;

  const totalCommitsAllBranches =
    summary?.commits?.count_all_branches ??
    summary?.commits?.count_default_branch ??
    summary?.commits?.count ??
    0;

  const stats = [
    {
      title: "Total Commits",
      value: totalCommitsAllBranches,
      icon: <FaGitAlt size={28} />,
      color: "#6366f1", // Indigo
    },
    {
      title: "Total Contributors",
      value: summary.total_contributors,
      icon: <FaUsers size={28} />,
      color: "#10b981", // Emerald
    },
    {
      title: "Total PRs",
      value: summary?.pull_requests?.all ?? 0,
      icon: <TbGitPullRequest size={28} />,
      color: "#f59e0b", // Amber
    },
    {
      title: "Open Issues",
      value: summary?.issues?.open_unfiltered ?? summary?.issues?.open ?? 0,
      icon: <FaCircleExclamation size={28} />, 
      color: "#ef4444", // Red
    },
    {
      title: "Closed Issues",
      value: summary?.issues?.closed_unfiltered ?? summary?.issues?.closed ?? 0,
      icon: <FaCircleCheck size={28} />,
      color: "#64748b", // Slate
    },
    {
      title: "Open PRs",
      value: summary?.pull_requests?.open ?? 0,
      icon: <FaCodeBranch size={28} />,
      color: "#0ea5e9", // Sky Blue
    },
    {
      title: "Total Branches",
      value: branchesTotal,
      icon: <FaFolderTree size={28} />,
      color: "#8b5cf6", // Violet
    },
    {
      title: "Merged PRs",
      value: summary?.pull_requests?.merged ?? 0,
      icon: <FaCodeMerge size={28} />,
      color: "#22c55e", // Green
    },
  ];

  const formatNumber = (num) => {
    if (typeof num !== "number") return "0";
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
  };

  return (
    <div className="card p-4 shadow-sm" style={{ height: "100%" }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">{title}</h5>
      </div>

      <div className="row g-3">
        {stats.map((stat, index) => (
          <div
            className="col-xl-3 col-lg-4 col-md-6"
            key={index}
            data-aos="flip-left"
          >
            <Card className="shadow-sm h-100 border-0 position-relative overflow-hidden">
              <div
                className="position-absolute top-0 start-0 w-100"
                style={{
                  height: "4px",
                  background: `linear-gradient(90deg, ${stat.color}, ${stat.color}80)`,
                }}
              />
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: `${stat.color}15`,
                      width: "60px",
                      height: "60px",
                      color: stat.color,
                    }}
                  >
                    {stat.icon}
                  </div>
                  <div className="text-end">
                    <h2 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
                      {formatNumber(stat.value)}
                    </h2>
                    <p className="text-muted mb-0 small fw-medium">
                      {stat.title}
                    </p>
                  </div>
                </div>
              </Card.Body>
              <div
                className="position-absolute bottom-0 end-0 opacity-10"
                style={{
                  width: "80px",
                  height: "80px",
                  background: `radial-gradient(circle, ${stat.color}20 0%, transparent 70%)`,
                }}
              />
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatCards;
